module.exports = __webpack_public_path__ + "static/img/CC BY-NC-SA.d83fe06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC BY-NC-SA.png
// module id = xIH6
// module chunks = 16